import Main from './main'
import Company from './company'
import Service from './service'
import Newsroom from './newsroom'
import Question from './question'
import Sustainability from './sustainability'
import Font from './font'
import Music from './music'
import InformationCenter from './informationCenter'
import Notice from './notice'
import Place from './place'
import Policy from './policy'
import Error from './error'
import Other from './other'

export const routes = [
  ...Main,
  ...Company,
  ...Service,
  ...Sustainability,
  ...Newsroom,
  ...Font,
  ...Music,
  ...Notice,
  ...Place,
  ...Policy,
  ...InformationCenter,
  ...Question,
  ...Error,
  // 삭제된 페이지 리다이렉팅 용
  ...Other,
]
